import { css } from '@emotion/css';
import { B400, N400 } from '@/colors/colorsV1';

export const styBreadcrumbList = css`
  list-style: none;
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 24px;
`;

export const styBreadcrumbSeparator = css`
  font-size: 20px;
  display: flex;
  color: ${N400};
  margin: 0 24px;
`;

export const styBreadcrumbLink = css`
  color: ${N400};
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    color: ${N400} !important;
  }
`;

export const styBreadcrumbActive = css`
  color: ${B400};
  font-size: 14px;
  font-weight: bold;
  cursor: default;
  pointer-events: none;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    color: ${B400};
  }
`;

export const styBreadcrumbLinkDisable = css`
  pointer-events: none;
`;
